export default "__VITE_ASSET__CWyYiidD__"